"use client";

import React from "react";
import { Navbar, Footer } from "@/components/layout/NavbarFooter";
import { useLanguage } from "@/context/LanguageContext";

export default function TermsConditions() {
  const { t } = useLanguage();

  return (
    <>
      <Navbar />
      <main className="min-h-screen bg-[#040d21] pt-32 pb-20 selection:bg-[#00f3ff] selection:text-[#040d21]">
        {/* Decorative elements */}
        <div className="absolute top-0 right-1/4 w-[500px] h-[500px] bg-[#0066ff]/5 rounded-full blur-[120px] pointer-events-none" />
        <div className="absolute bottom-0 left-1/4 w-[400px] h-[400px] bg-[#00f3ff]/5 rounded-full blur-[100px] pointer-events-none" />

        <div className="max-w-5xl mx-auto px-6 relative z-10">
          <div className="bg-[#0a192f]/60 backdrop-blur-2xl rounded-[3rem] border border-[#00f3ff]/10 p-8 md:p-16 shadow-[0_20px_50px_rgba(0,0,0,0.5)] group hover:border-[#00f3ff]/20 transition-all duration-500">
            <h1 className="text-4xl md:text-6xl font-black text-white mb-12 tracking-tighter leading-tight">
              Điều khoản Sử dụng{" "}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#00f3ff] to-[#0066ff] drop-shadow-[0_0_15px_rgba(0,243,255,0.3)]">
                AHV Holding
              </span>
            </h1>

            <div className="space-y-10 text-slate-300 font-medium leading-relaxed">
              <section className="space-y-4">
                <p className="text-lg">
                  Các điều khoản và điều kiện này áp dụng cho các dịch vụ và sản phẩm công nghệ
                  do Công ty Cổ phần Đầu tư AHV Holding (sau đây gọi tắt là
                  &quot;Nhà cung cấp Dịch vụ&quot;) phát triển và cung cấp, bao gồm ứng dụng
                  AHV Work và các nền tảng số liên quan.
                </p>
                <p>
                  Khi tải xuống, truy cập hoặc sử dụng các dịch vụ của AHV Holding, bạn
                  được xem là tự động đồng ý với các điều khoản sau đây. Chúng tôi khuyến
                  nghị bạn đọc kỹ và hiểu rõ các điều khoản này trước khi sử dụng dịch vụ.
                </p>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-bold text-white flex items-center gap-3">
                  <span className="w-2 h-8 bg-gradient-to-b from-[#00f3ff] to-[#0066ff] rounded-full" />
                  Quyền Sở hữu Trí tuệ
                </h2>
                <p>
                  Nghiêm cấm việc sao chép, chỉnh sửa trái phép các ứng dụng, sản phẩm,
                  bất kỳ phần nào của sản phẩm hoặc thương hiệu của AHV Holding. Mọi hành vi
                  trích xuất mã nguồn, dịch ngược hoặc tạo các phiên bản phái sinh đều
                  không được phép. Tất cả các nhãn hiệu, bản quyền, quyền cơ sở dữ liệu
                  và các quyền sở hữu trí tuệ khác liên quan đến sản phẩm đều thuộc sở hữu
                  của AHV Holding.
                </p>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-bold text-white flex items-center gap-3">
                  <span className="w-2 h-8 bg-gradient-to-b from-[#00f3ff] to-[#0066ff] rounded-full" />
                  Sửa đổi và Phí dịch vụ
                </h2>
                <p>
                  AHV Holding cam kết đảm bảo rằng các sản phẩm và dịch vụ luôn hữu ích và
                  hiệu quả nhất có thể. Do đó, chúng tôi có quyền sửa đổi sản phẩm hoặc
                  tính phí cho dịch vụ bất kỳ lúc nào và vì bất kỳ lý do nào. AHV Holding
                  đảm bảo rằng mọi khoản phí liên quan đến sản phẩm hoặc dịch vụ sẽ được
                  thông báo rõ ràng đến bạn trước khi áp dụng.
                </p>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-bold text-white flex items-center gap-3">
                  <span className="w-2 h-8 bg-gradient-to-b from-[#00f3ff] to-[#0066ff] rounded-full" />
                  Dữ liệu và Bảo mật
                </h2>
                <p>
                  Các sản phẩm của AHV Holding lưu trữ và xử lý dữ liệu cá nhân mà bạn
                  đã cung cấp nhằm mục đích cung cấp dịch vụ. Bạn có trách nhiệm duy trì
                  tính bảo mật cho thiết bị và quyền truy cập vào các ứng dụng của mình.
                </p>
                <div className="p-6 bg-red-500/5 border border-red-500/20 rounded-[2rem] text-slate-300">
                  <strong className="text-white block mb-2">Cảnh báo:</strong>
                  AHV Holding khuyến cáo bạn không nên jailbreak hoặc root điện thoại của mình,
                  tức là loại bỏ các hạn chế và giới hạn phần mềm do hệ điều hành chính
                  thức áp đặt trên thiết bị. Những hành động này có thể khiến điện thoại
                  của bạn bị nhiễm phần mềm độc hại, vi-rút, các chương trình gây hại,
                  làm suy yếu các tính năng bảo mật và có thể khiến ứng dụng không hoạt
                  động đúng cách hoặc hoàn toàn không hoạt động.
                </div>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-bold text-white flex items-center gap-3">
                  <span className="w-2 h-8 bg-gradient-to-b from-[#00f3ff] to-[#0066ff] rounded-full" />
                  Dịch vụ Bên Thứ ba
                </h2>
                <p>
                  Xin lưu ý rằng các sản phẩm của AHV Holding có sử dụng các dịch vụ của
                  bên thứ ba với Điều khoản và Điều kiện riêng. Dưới đây là các liên kết
                  đến Điều khoản và Điều kiện của các nhà cung cấp dịch vụ bên thứ ba:
                </p>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-6">
                  {[
                    { name: "Google Play Services", url: "https://policies.google.com/terms" },
                    { name: "AdMob", url: "https://developers.google.com/admob/terms" },
                    { name: "Google Analytics for Firebase", url: "https://www.google.com/analytics/terms/" },
                    { name: "Firebase Crashlytics", url: "https://firebase.google.com/terms/crashlytics" },
                    { name: "Facebook", url: "https://www.facebook.com/legal/terms/plain_text_terms" },
                  ].map((link, i) => (
                    <a
                      key={i}
                      href={link.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center justify-between p-4 bg-[#040d21]/40 border border-[#00f3ff]/10 rounded-2xl hover:border-[#00f3ff]/40 hover:bg-[#00f3ff]/5 transition-all group/link"
                    >
                      <span className="font-bold text-white group-hover/link:text-[#00f3ff] transition-colors">{link.name}</span>
                      <span className="material-symbols-outlined text-sm text-[#00f3ff] opacity-0 group-hover/link:opacity-100 transition-all transform translate-x-[-10px] group-hover/link:translate-x-0">
                        open_in_new
                      </span>
                    </a>
                  ))}
                </div>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-bold text-white flex items-center gap-3">
                  <span className="w-2 h-8 bg-gradient-to-b from-[#00f3ff] to-[#0066ff] rounded-full" />
                  Giới hạn Dịch vụ
                </h2>
                <p>
                  Xin lưu ý rằng AHV Holding không chịu trách nhiệm đối với một số khía
                  cạnh nhất định. Một số chức năng của sản phẩm yêu cầu kết nối internet
                  hoạt động. AHV Holding không chịu trách nhiệm nếu sản phẩm không hoạt
                  động đầy đủ do thiếu kết nối Wi-Fi hoặc bạn đã sử dụng hết lưu lượng
                  dữ liệu di động.
                </p>
                <p>
                  Khi sử dụng sản phẩm, bạn chấp nhận trách nhiệm đối với mọi khoản phí
                  từ nhà mạng di động của mình, bao gồm phí dữ liệu chuyển vùng nếu bạn
                  sử dụng sản phẩm ngoài lãnh thổ quốc gia.
                </p>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-bold text-white flex items-center gap-3">
                  <span className="w-2 h-8 bg-gradient-to-b from-[#00f3ff] to-[#0066ff] rounded-full" />
                  Trách nhiệm
                </h2>
                <p>
                  AHV Holding không phải lúc nào cũng chịu trách nhiệm đối với cách
                  bạn sử dụng sản phẩm. Ví dụ, bạn có trách nhiệm đảm bảo thiết bị
                  của mình luôn được sạc đầy đủ.
                </p>
                <p>
                  Mặc dù chúng tôi luôn nỗ lực đảm bảo thông tin được cập nhật và chính xác,
                  chúng tôi có dựa vào các bên thứ ba để cung cấp thông tin. AHV Holding
                  không chịu trách nhiệm đối với bất kỳ tổn thất nào, trực tiếp hoặc gián
                  tiếp, mà bạn gặp phải do hoàn toàn phụ thuộc vào chức năng này của
                  sản phẩm.
                </p>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-bold text-white flex items-center gap-3">
                  <span className="w-2 h-8 bg-gradient-to-b from-[#00f3ff] to-[#0066ff] rounded-full" />
                  Chấm dứt và Cập nhật
                </h2>
                <p>
                  AHV Holding có thể cập nhật sản phẩm tại bất kỳ thời điểm nào.
                  Bạn cần tải xuống các bản cập nhật nếu muốn tiếp tục sử dụng sản phẩm.
                  AHV Holding cũng có thể ngừng cung cấp sản phẩm và chấm dứt việc sử dụng
                  bất kỳ lúc nào mà không cần thông báo trước cho bạn.
                </p>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-bold text-white flex items-center gap-3">
                  <span className="w-2 h-8 bg-gradient-to-b from-[#00f3ff] to-[#0066ff] rounded-full" />
                  Thay đổi Điều khoản
                </h2>
                <p>
                  AHV Holding có thể cập nhật Điều khoản và Điều kiện theo định kỳ.
                  Do đó, bạn nên xem lại trang này thường xuyên để nắm bắt các thay đổi.
                  Chúng tôi sẽ thông báo cho bạn về bất kỳ thay đổi nào bằng cách đăng
                  Điều khoản và Điều kiện mới trên trang này.
                </p>
                <p className="font-bold text-[#00f3ff]">
                  Các điều khoản và điều kiện này có hiệu lực từ ngày 03-02-2026
                </p>
              </section>

              <hr className="border-[#00f3ff]/10 my-10" />

              <div className="text-center text-sm text-slate-400">
                <p>
                  Nếu bạn có bất kỳ câu hỏi hoặc đề xuất nào về Điều khoản và Điều kiện,
                  vui lòng liên hệ với chúng tôi tại{" "}
                  <a href="mailto:ahvholding.com@gmail.com" className="text-[#00f3ff] hover:underline font-bold">
                    ahvholding.com@gmail.com
                  </a>.
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}
